import { useQuery } from 'react-apollo';
import { useSelector } from 'react-redux';

import { MeWithPurchasedPrintPackages } from '../../../../../../../../graphql/queries/account';
import { PURCHASED_PRINT_PACKAGE_STATUS } from '../../../../../../../../constants/print-packages';
import { AlbumFolderWithPurchasablePrintPackages } from '../../../../../../../../graphql/queries/album-folder';
import { getAlbumMembershipGroupQuery } from '../../../../../../../temp/views/memberships/AlbumMembershipGroup/graphql/queries/getAlbumMembershipGroup';
import { getPurchasedPrintPackagesMissingConfiguration } from '../helpers';
import { AlbumForWebGalleriesPurchases } from '../../../graphql/queries/album';

const usePurchasesPendingConfiguration = ({ hierarchyItemId }) => {
  const cart = useSelector(({ checkout }) => checkout.cart);
  const { data: { albumMembershipGroup } = {} } = useQuery(
    getAlbumMembershipGroupQuery,
    {
      variables: {
        id: hierarchyItemId,
      },
      skip: !hierarchyItemId,
      fetchPolicy: 'cache-first',
    },
  );

  const { data: { album } = {} } = useQuery(AlbumForWebGalleriesPurchases, {
    variables: {
      id: hierarchyItemId,
    },
    skip: !hierarchyItemId,
  });

  const albumFolderId = (() => {
    if (albumMembershipGroup) {
      return albumMembershipGroup.is_album
        ? albumMembershipGroup?.album?.root_album_folder?.id
        : albumMembershipGroup.id;
    }

    return album?.root_album_folder?.id;
  })();

  const { data: { me: meWithPurchasedPrintPackages } = {} } = useQuery(
    MeWithPurchasedPrintPackages,
    {
      variables: {
        album_folder_id: albumFolderId,
      },
      skip: !albumFolderId,
    },
  );

  const { data: { me } = {} } = useQuery(MeWithPurchasedPrintPackages, {
    variables: {
      is_prepaid: true,
      album_folder_id: albumFolderId,
      status: PURCHASED_PRINT_PACKAGE_STATUS.PENDING,
    },
    skip: !albumFolderId,
  });

  const { data: { albumFolder } = {} } = useQuery(
    AlbumFolderWithPurchasablePrintPackages,
    {
      variables: {
        id: albumFolderId,
      },
      skip: !albumFolderId,
    },
  );

  const albumPrintPackages =
    albumFolder?.album_folder_print_packages?.records ?? [];
  const prepaidPrintPackages = me?.purchased_print_packages?.records ?? [];
  const hasPurchasedPrintPackages =
    (me?.purchased_print_packages?.total ?? 0) > 0 ||
    (meWithPurchasedPrintPackages?.purchased_print_packages?.total ?? 0) > 0;

  const albumMembershipGroupEntity = albumMembershipGroup ?? {
    id: album?.id ?? albumFolder?.id,
    album,
    is_album: !!album,
    album_folder: album ? undefined : albumFolder,
  };

  const isAllPhotos = !albumMembershipGroup && !!album;

  return {
    isAllPhotos,
    albumMembershipGroup: albumMembershipGroupEntity,
    albumPrintPackages,
    prepaidPrintPackages,
    hasPurchasedPrintPackages,
    prepaidPrintPackagesMissingConfiguration: getPurchasedPrintPackagesMissingConfiguration(
      cart,
      prepaidPrintPackages,
    ),
  };
};

export default usePurchasesPendingConfiguration;
